import { createFileRoute } from '@tanstack/react-router';
import { LoginScreen } from '../screens/Login/LoginScreen';

export const Route = createFileRoute('/login')({
  component: LoginScreen,
});
